import { MayNull } from '@apeiron/temp'
import { useMutation } from '@apollo/client'
import gql from '@src/graphql/mutation/signDailyCheckInMakeup'

const useSignDailyCheckInMakeup = () => {
  const [signDailyCheckInMakeup, { loading }] = useMutation(gql)

  const mutate = async (
    campaignID: string,
    missedClaimedCount: number
  ): Promise<MayNull<SignCheckInMakeupReturn>> => {
    const res = await signDailyCheckInMakeup({
      variables: {
        campaignID,
        missedClaimedCount
      }
    })

    return res.data?.signDailyCheckInMakeup
  }

  return {
    mutate,
    loading
  }
}

type SignCheckInMakeupReturn = {
  walletAddress: string
  campaignID: string
  maxMakeupCount: number
  makeupDayCount: number
  animusUse: string
  signTimeInSec: string
  signature: string
}

export default useSignDailyCheckInMakeup
